import { useMemo } from 'react';

import { usePaginationSelector } from '#pagination/context/hooks/selector.hook';

/**
 * Custom React hook that calculates the total number of pages based on the current
 * pagination context's `total` item count and `pageSize`.
 *
 * Utilizes `usePaginationSelector` to retrieve the `total` and `pageSize` values from context,
 * and memoizes the result using `useMemo` for performance optimization.
 *
 * @returns {number} The total number of pages, computed as `Math.ceil(total / pageSize)`.
 */
export const useTotalPages = () => {
  const pageSize = usePaginationSelector(({ pageSize }) => {
    return pageSize;
  });
  const total = usePaginationSelector(({ total }) => {
    return total;
  });

  return useMemo(() => {
    return Math.ceil(total / pageSize);
  }, [total, pageSize]);
};
